import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from "@angular/material/snack-bar";
import { ErrorDisplayComponent } from "../error-display/error-display.component";
import {
  SNACKBAR_FEATURES,
  SNACKBAR_TOKENS,
  SnackbarType,
} from "./snackbar.models";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ButtonComponent } from "../button/button.component";

@Component({
  selector: "app-snackbar-custom",
  templateUrl: "./snackbar-custom.component.html",
  styleUrls: ["./snackbar-custom.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ErrorDisplayComponent,
    AngularSvgIconModule,
    ButtonComponent,
  ],
})
export class SnackbarCustomComponent {
  showCloseIcon: boolean = false;
  snackbarStyles: Record<string, string> = {};

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarCustomComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { message: string; actionText?: string; type?: SnackbarType }
  ) {
    this.showCloseIcon = SNACKBAR_FEATURES[this.data.type]?.showIcon ?? false;
    this.snackbarStyles = SNACKBAR_TOKENS[this.data.type] || {};
  }

  onAction() {
    this.snackBarRef.dismissWithAction();
  }

  onClose() {
    this.snackBarRef.dismiss();
  }
}
